module.exports = __webpack_public_path__ + "static/media/panco_04.b88ebcf5.jpg";